export default __webpack_public_path__ + "static/media/story.25b8eae6.svg";